import React, { useEffect, useState } from "react";
import { Badge } from "reactstrap";
import { useFetchData } from "hooks/apiHooks";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import IconButtonWithTooltip from "components/buttons/IconButtonWithTooltip";
import { useTranslation } from "react-i18next";
import { API_ENDPOINTS } from "constants";
import AsyncCreatableSelect from "react-select/async-creatable";
import useConfirmation from "hooks/useConfirmation";
import DeleteConfirmationModal from "components/modals/DeleteConfirmationModal";
import { select } from "@syncfusion/ej2-react-schedule";

function BadgeSelector({obj, assignedBadges = [], saveBadges, addBadges=true, showSuggestions}) {
    const { t } = useTranslation();
    const badges = Array.isArray(assignedBadges)
        ? assignedBadges
        : (assignedBadges != null && assignedBadges !== '' ? [assignedBadges] : []);
    const { isLoading, error, refetch} = useFetchData(API_ENDPOINTS[obj.toUpperCase()].CATEGORIES, null, false);
    const [selectedOptions, setSelectedOptions] = useState(badges.map(badge => {return {label: badge, value: badge}}));
    const [editMode, setEditMode] = useState(false);
    const [suggestions, setSuggestions] = useState(null);

    useEffect(() => {
        setSelectedOptions(badges.map(badge => ({ label: badge, value: badge })));
    }, [JSON.stringify(badges)]);

    useEffect(() => {
        if(showSuggestions && suggestions === null){
            fetchSuggestions('').then(suggestions => setSuggestions(suggestions))
        } 
    }, [showSuggestions]);

    const setAndSave = (options) => {
        console.log(options)
        const nextOptions = options || [];
        setSelectedOptions(nextOptions);
        saveBadges(nextOptions.map(option => option.value))
    };

    const confirmEmpty = useConfirmation(setAndSave)

    const fetchSuggestions = async (inputValue) => {
        const suggestions = await refetch({searchTerm: inputValue.toLowerCase()})
        return suggestions
    };

    const handleCreateOption = async (inputValue) => {    
        if(selectedOptions){
            setAndSave([...selectedOptions, { label: inputValue, value: inputValue }])
        }
        else setAndSave([{ label: inputValue, value: inputValue }])
    };

    const handleChange = (options) => {
        if ((!options || options.length === 0) && selectedOptions.length > 1) {
            return confirmEmpty.requestConfirmation(options)
        } else setAndSave(options)
    }

    const handleSelect = (item) =>{
        const exists = selectedOptions.some(option => option.value === item.value);
        if (exists) {
            setAndSave(selectedOptions.filter(option => option.value !== item.value));
        } else {
            setAndSave([...selectedOptions, item]);
        }    
    }

    if(editMode && !showSuggestions) return (
        <>
            <DeleteConfirmationModal {...confirmEmpty.modalProps} />
            <AsyncCreatableSelect 
                cacheOptions
                isMulti
                loadOptions={fetchSuggestions}
                value={selectedOptions}
                placeholder={t("categorySelector.placeholder")}
                noOptionsMessage={() => t("categorySelector.emptyResult")}
                formatCreateLabel={(inputValue) => t("categorySelector.add", { key: inputValue})} 
                onCreateOption={handleCreateOption} 
                onChange={handleChange}
                onBlur={() => setEditMode(false)} 
                styles={{
                    control: base => ({ ...base, minHeight: "40px" }),
                    menu: base => ({ ...base, zIndex: 99999999 }),
                }}
                isLoading={isLoading}
            />  
        </>)
    
    return (
        <>
            {showSuggestions ?
                suggestions?.length > 0 && suggestions.map((item) => (
                    <Badge key={item.value} color={badges.some(option => option === item.value) ? "danger" : "primary"} className="me-2" style={{ cursor: 'pointer' }} onClick={() => handleSelect(item)}>
                        {item.label}
                    </Badge>
            )) : badges.map((folder, index) => (
                <Badge key={index} color={'danger'}>
                    {folder}
                </Badge>
            ))}

            {addBadges && 
                <Badge>
                    <IconButtonWithTooltip translationId="categorySelector.edit" icon={faPen} type="IconOnly" size="sm" onClick={() => setEditMode(true)}/>
                </Badge>
            }
        </>
    )
}

export default BadgeSelector;
